import Experience from "../Experience"

export default class TowerInterior {
  constructor () {
    this.experience = new Experience();
    this.resources = this.experience.resources.items;
    this.container = document.querySelector(".tower-interior");

    this.container.appendChild(this.resources.towerInterior);
  }
}